import { DropdownButtonType, ListItem, LocallyFilteringList, SingleSelectDropdown } from '@tableau/widgets';
import { FormikContextType } from 'formik';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import {
  AllowPulseFeatureSectionProps,
  DIGEST_START_TIME_SITE_SETTING
} from '~src/settings/general-settings/components/sections/pulse/PulseFeatureSection';
import { dropdownListStyle } from '~src/settings/styles/CommonStyles';

const digestStartTimeDropdownWrapperStyle = style({
  display: 'flex'
});

const digestStartTimeDropdownStyle = style({
  maxWidth: '184px',
});

const timeZoneNameContainerStyle = style({
  alignContent: 'flex-end'
});

const timeZoneNameStyle = style({
  height: '22px',  // same height as the dropdown
  display: 'flex',
  alignItems: 'center',
  padding: '1px', // account for the border on the dropdown
  marginLeft: '16px',
});

const minutesToString = (minutesSinceMidnight: number | undefined): string => {
  if (!minutesSinceMidnight) {
    return '00:00';
  }
  const hours = Math.floor(minutesSinceMidnight / 60);
  const minutes = minutesSinceMidnight - (hours * 60);
  const hoursStr = `${hours < 10 ? '0' : ''}${hours}`;
  const minutesStr = `${minutes < 10 ? '0' : ''}${minutes}`;
  return `${hoursStr}:${minutesStr}`;
};

const numberOfFiveMinuteIncrementsInOneDay = 60 * 24 / 5;

const digestStartTimesList: ListItem[] = Array.from(Array(numberOfFiveMinuteIncrementsInOneDay).keys()).map(n => {
  const minutesSinceMidnight = n * 5;
  return {content: minutesToString(minutesSinceMidnight), value: `${minutesSinceMidnight}`};
});

export function PulseDigestSchedule(formik: FormikContextType<AllowPulseFeatureSectionProps>): JSX.Element {
  const timeZone = formik.values.settings.useDefaultTimeZone ? 'UTC' : formik.values.settings.timeZone;
  const timeZonesListItems = formik.values.timeZonesListItems;
  const timeZoneDisplayName = timeZonesListItems?.find(item => item.value === timeZone)?.content ?? '';

  function setDigestStartTime(value: string) {
    formik.setFieldValue(DIGEST_START_TIME_SITE_SETTING, parseInt(value, 10));
  }

  const itemFilterFn = (item: ListItem, filter: string) => item.content.toString().includes(filter.toLowerCase());

  return (
    <div>
      <p>{Messages.pulseDigestScheduleSiteSettingDescription()}</p>
      <div className={digestStartTimeDropdownWrapperStyle}>
        <SingleSelectDropdown
          label={Messages.pulseDigestScheduleSiteSettingStartTime()}
          aria-label={Messages.pulseDigestScheduleSiteSettingStartTime()}
          list={<LocallyFilteringList items={digestStartTimesList} className={dropdownListStyle}
                                      itemFilterFn={itemFilterFn}/>}
          onChange={setDigestStartTime}
          type={DropdownButtonType.Outline}
          value={minutesToString(formik.values.settings.siteSettingsV2?.pulseDigestStartTime)}
          className={digestStartTimeDropdownStyle}
        />
        <div className={timeZoneNameContainerStyle}>
          <div className={timeZoneNameStyle}>
            {timeZoneDisplayName}
          </div>
        </div>
      </div>
    </div>
  );
}
